import "../../Styles/Galery.scss";
import React from "react";


import original_1 from "../../img/Switzerland/Gallery_1.jpeg";
import original_2 from "../../img/Switzerland/Gallery_2.jpg";
import original_3 from "../../img/Switzerland/Gallery_3.jpg";
import original_4 from "../../img/Switzerland/Gallery_4.jpg";
import original_5 from "../../img/Switzerland/Gallery_5.jpeg";
import original_6 from "../../img/Switzerland/Gallery_6.jpeg";
import original_7 from "../../img/Switzerland/Gallery_7.jpeg";
import original_8 from "../../img/Switzerland/Gallery_8.jpeg";
import original_9 from "../../img/Switzerland/Gallery_9.jpeg";
import original_10 from "../../img/Switzerland/Gallery_10.jpeg";
import original_11 from "../../img/Switzerland/Gallery_11.jpeg";
import original_12 from "../../img/Switzerland/Gallery_12.jpeg";
import original_13 from "../../img/Switzerland/Gallery_13.jpeg";
import original_14 from "../../img/Switzerland/Gallery_14.jpeg";
import original_15 from "../../img/Switzerland/Gallery_15.jpeg";
import original_16 from "../../img/Switzerland/Gallery_16.jpeg";
import original_17 from "../../img/Switzerland/Gallery_17.jpeg";
import original_18 from "../../img/Switzerland/Gallery_18.jpeg";
import original_19 from "../../img/Switzerland/Gallery_19.jpeg";
import original_20 from "../../img/Switzerland/Gallery_20.jpg";
import original_21 from "../../img/Switzerland/Gallery_21.jpeg";

import ImageGallery from "react-image-gallery";
const images = [
    {
        original: original_1,
    },
    {
        original: original_2,
    },
    {
        original: original_3,
    },
    {
        original: original_4,
    },
    {
        original: original_5,
    },
    {
        original: original_6,
    },
    {
        original: original_7,
    },
    {
        original: original_8,
    },
    {
        original: original_9,
    },
    {
        original: original_10,
    },
    {
        original: original_11,
    },
    {
        original: original_12,
    },
    {
        original: original_13,
    },
    {
        original: original_14,
    },

    {
        original: original_15,
    },
    {
        original: original_16,
    },
    {
        original: original_17,
    },
    {
        original: original_18,
    },
    {
        original: original_19,
    },
    {
        original: original_20,
    },
    {
        original: original_21,
    },
];

function ItalyGallery() {
    return (
        <div className="pageContainer space">
            <div className="gallery-container">
                <div className="image-gallery-wrapper pictures">
                    <ImageGallery
                        items={images}
                        disableThumbnailScroll={true}
                        showThumbnails={false}
                        showBullets={true}
                    />
                </div>
            </div>
        </div>
    );
}

export default ItalyGallery;
